/* DirectoryFilters — شَريط فَلاتر بحث الدَّليل (المُحافَظة + القَضاء + الاختصاص + بحث نَصّي). */
import { MagnifyingGlass, MapPin, Buildings, Scales, FunnelSimple } from "@phosphor-icons/react";

const GOVERNORATES = [
  "", "بَغداد", "البَصرة", "نَينَوى", "أَربيل", "كَربلاء", "النَّجَف",
  "ذي قار", "بابل", "الأَنبار", "ديالى", "كركوك", "صلاح الدِّين",
  "واسط", "ميسان", "المُثَنَّى", "القادِسيَّة", "دَهوك", "السُّلَيمانيَّة",
];

const SPECIALTIES = [
  "", "مَدنيّ", "جَزائيّ", "أحوال شخصيّة", "تجاريّ", "عَقاريّ",
  "إداريّ", "عُمَّاليّ", "ضَريبيّ", "دَوليّ", "مِلكيّة فِكريّة",
];

export default function DirectoryFilters({ q, setQ, governorate, setGovernorate, district, setDistrict, specialty, setSpecialty, onSubmit }) {
  return (
    <form onSubmit={onSubmit} className="bg-white rounded-[24px] p-3 border border-[#EAEAEA] shadow-[0_4px_18px_rgba(10,25,47,0.06)]">
      <div className="flex items-center gap-2 px-2 mb-2">
        <MagnifyingGlass size={16} className="text-[#5A6470]" weight="bold" />
        <input
          type="text"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="ابحث بِالاسم أو السيرة"
          data-testid="dir-search-q"
          className="flex-1 bg-transparent outline-none text-[14px] py-2"
        />
      </div>

      <div className="grid grid-cols-2 gap-2 mb-2">
        <div className="relative">
          <Buildings size={14} weight="duotone" className="absolute right-2.5 top-1/2 -translate-y-1/2 text-[#D4AF37] pointer-events-none" />
          <select
            value={governorate}
            onChange={(e) => setGovernorate(e.target.value)}
            data-testid="dir-filter-gov"
            className="w-full pr-8 pl-3 py-2.5 rounded-xl border border-[#EAEAEA] bg-white text-[13px] outline-none focus:border-[#D4AF37] appearance-none"
          >
            <option value="">المُحافَظة (الكل)</option>
            {GOVERNORATES.filter(Boolean).map((g) => (
              <option key={g} value={g}>{g}</option>
            ))}
          </select>
        </div>
        <div className="relative">
          <MapPin size={14} weight="duotone" className="absolute right-2.5 top-1/2 -translate-y-1/2 text-[#D4AF37] pointer-events-none" />
          <input
            type="text"
            value={district}
            onChange={(e) => setDistrict(e.target.value)}
            placeholder="القَضاء (اختياريّ)"
            data-testid="dir-filter-district"
            className="w-full pr-8 pl-3 py-2.5 rounded-xl border border-[#EAEAEA] bg-white text-[13px] outline-none focus:border-[#D4AF37]"
          />
        </div>
      </div>

      <div className="flex items-center gap-2 mb-2">
        <div className="relative flex-1">
          <Scales size={14} weight="duotone" className="absolute right-2.5 top-1/2 -translate-y-1/2 text-[#D4AF37] pointer-events-none" />
          <select
            value={specialty}
            onChange={(e) => setSpecialty(e.target.value)}
            data-testid="dir-filter-specialty"
            className="w-full pr-8 pl-3 py-2.5 rounded-xl border border-[#EAEAEA] bg-white text-[13px] outline-none focus:border-[#D4AF37] appearance-none"
          >
            <option value="">الاختصاص (الكل)</option>
            {SPECIALTIES.filter(Boolean).map((s) => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
        </div>
        <button
          type="submit"
          data-testid="dir-search-submit"
          className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full bg-[#0A192F] text-white text-[13px] font-bold active:scale-95 transition"
        >
          <FunnelSimple size={13} weight="bold" />
          تَطبيق
        </button>
      </div>
    </form>
  );
}
